import React from 'react';
import { connect } from 'react-redux';
import { createPolling } from 'redux-polling-thunk';
import OpponentTeam from './OpponentTeam';
import DrawRound from './DrawRound';
import SelectArmyDraw from './SelectArmyDraw';
import Matches from './Matches';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { container } from '@Container';
import { TYPES } from '@Types';
import { OpponentDraftTeamAction } from '@Redux/actions';
import toast from 'react-hot-toast';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Col, FormGroup } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import pollingSlice from '@Redux/reducers/polling.slice';
import { defaultMessages } from '@I18n/default';

const DraftComponent: React.FC<DraftProps> = ({
                                                draft,
                                                draftClosed,
                                                opponentTeam,
                                                opponentTeamCreated,
                                                loadOpponentTeam
                                              }) => {
  if (!opponentTeamCreated) {
    React.useEffect(() => {
      loadOpponentTeam();
    }, []);

    const opponantUrl = `${window.location.origin}/${document.documentElement.lang}/tool/pairing/teams/${opponentTeam.id}/new`;

    const copied = () => toast.success('Copied!');

    return (
      <FormGroup row={true} className="text-center justify-content-md-center m-5">
        <Col xs={12} md={6}>
          <h1><FormattedMessage {...defaultMessages.toolPairingDraftWaitingOpponent} /></h1>
          <p><FormattedMessage {...defaultMessages.toolPairingDraftSendLink} /></p>
          <div className="m-3">
            <input type="text" readOnly className="form-control" value={opponantUrl} />
            <div>
              <CopyToClipboard text={opponantUrl} onCopy={() => copied()}>
                <button className="btn btn-age"><i className="fa actions fa-copy" /> Copy to clipboard</button>
              </CopyToClipboard>
            </div>
          </div>
        </Col>
      </FormGroup>
    );
  }

  if (draftClosed) {
    window.location.href = `/${document.documentElement.lang}/tool/pairing/drafts/${draft.id}`;
    return (
      <Matches />
    );
  }

  return (
    <div>
      <OpponentTeam />
      <DrawRound />
      <SelectArmyDraw />
      <Matches />
    </div>
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    draft: state.draft.entity!,
    opponentTeam: state.opponentTeam.entity!,
    opponentTeamCreated: (state.opponentTeam.entity?.teamArmies?.length ?? 0) > 0,
    draftClosed: state.draft.entity?.size == state.matches.entity?.length
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  const opponentTeamAction = container.get<OpponentDraftTeamAction>(TYPES.Actions.Tool.OpponentDraftTeamAction);

  return {
    loadOpponentTeam: () => {
      dispatch(() => {
        dispatch(
          createPolling('opponent-team-created-check', {
            getPollingRegistration: (state, name) => state.polling.entity?.includes(name) ?? false,
            registerPolling: name => pollingSlice.actions.register(name),// dispatch an action to register the polling
            unregisterPolling: name => pollingSlice.actions.unregister(name),// dispatch an action to unregister the polling,
            fetchFunction: () => opponentTeamAction.loadOpponentTeamRequest(),
            shouldStartCondition: () => true,
            shouldContinueCondition: (result) => !result,
            onError: (error) => console.log('error', error),
            onFinish: () => console.log('finish'),
            timeout: 10000
          })
        );
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DraftComponent);

type DraftProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
